import React, { Component } from 'react'
import Card from './CardUI';

import img1 from "../../assets/clay-banks-e6pK_snssSY-unsplash (1) (1).jpg";
import img2 from "../../assets/shutterstock_645685942-800x450 (1) (1).jpg";
import img3 from "../../assets/Keep Working On It (1).jpg";


export default class Cards extends Component {
    render() {
        return(
            <div className="container-fluid d-flex justify-content-center">
                <div className="row">
                    <div className="col-md-4">
                        <Card imgsrc={img1} title="Scheduled Operations" description="Calendar of scheduled operations" href="/calendar"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img2} title="Candidates" description="Potential patients for surgeries" href="/pre_operation/patients"/>
                    </div>
                    <div className="col-md-4">
                        <Card imgsrc={img3} title="Allocated Rooms" description="<Room, Day>s of Ward" href="/preoporthopedic/patients"/>
                    </div>
                </div>
            </div>
        )
    }
}